import * as WebFont from "webfontloader";
import BaseScene from "./BaseScene";

// import spritesheets
// example
import submitButton from "../../assets/img/submit-button-background-sprite-sheet.png";
import submitButtonNarrow from "../../assets/img/submit-narrow-background.png";
import soundIcon from "../../assets/img/icon-sound-sprite-sheet.png";
import fanButton from "../../assets/img/fanButton.png";
import keyPad from "../../assets/img/secret-code-button-sprite-sheet.png";
import codeBg from "../../assets/img/secret-code-text-box.png";
import asteriskBg from "../../assets/img/secret-code-input-box.png";
import blurEdge from "../../assets/img/blurry-boarder.png";
import gameOverBox from "../../assets/img/game-over-text-box.png";
import gameOverWhite from "../../assets/img/game-over-white-box-score.png";
import alertGlow from "../../assets/img/alertGlow.png";
import fullBattery from "../../assets/img/winbattery.png";
import loseBattery from "../../assets/atlas/losebattery-spritesheet.png";

// import audio files
// example
//import boop from "../../assets/audio/Navigation_Button_19.ogg";
import boopMp3 from "../../assets/audio/Navigation_Button_19.mp3";
import correctSFX from "../../assets/audio/Simple_Tone_43.mp3";
import incorrectSFX from "../../assets/audio/BB_DRL__086.mp3";
import pingSFX from "../../assets/audio/Telemetry_13.mp3";

import RunnerSpriteTexture from "../../assets/atlas/endlessRunner.png";
import RunnerSpriteData from "../../assets/atlas/endlessRunner.json";

/**
 *
 * @category scenes
 * @export
 * @class Boot
 * @extends {BaseScene}
 */
export default class Boot extends BaseScene {
  constructor() {
    // active true means the state always runs. from experience with Phaser2CE, best to keep this contructor free and used pleload / boot and creat for custom fucntionallity/.
    super(
      { key: "Boot", active: true } // we are always going to be active.
    );
  }

  /**
   * preload anything required for the experience.
   *
   * @memberof Boot
   */
  preload(): void {
    super.preload();
    if (!this.game.device.browser.ie) {
      // show Boilerplate version
      const args = [
        `%c %c %c Sponge - Luigi-1.4.4 Phaser ${Phaser.VERSION} %c %c `,
        "font-size: 12px; background: #d8dd0b;",
        "font-size: 12px; background: #0044ff;",
        "color: #fff; font-size: 12px; background: #45b245;",
        "font-size: 12px; background: #0044ff;",
        "font-size: 12px; background: #d8dd0b;",
      ];

      console.log(...args);

      // show game version
      const args2 = [
        "%c %c %c %c " +
          this.sponge.data.model.save.identifier +
          " - " +
          this.sponge.data.model.save.version +
          " %c %c %c ", // // https://getemoji.com/
        "font-size: 8px; background: #F0C25A", // custom colours
        "font-size: 10px; background: #33A995",
        "font-size: 12px; background: #F0394F;",
        "color: #DAEAF0; font-size: 12px; background: #233648;",
        "font-size: 12px; background: #F0394F;",
        "font-size: 10px; background: #33A995",
        "font-size: 8px; background: #F0C25A",
      ];

      console.log(...args2);
    }

    // we are going to colapse any log messages here unitl we are fully booted.
    console.log("Boot::preload::start");

    // load global assets here
    // images

    this.load.image("codeBg", codeBg);
    this.load.image("asteriskBg", asteriskBg);
    this.load.image("blurEdge",blurEdge);
    this.load.image("gameOverBox",gameOverBox);
    this.load.image("gameOverWhite",gameOverWhite);
    this.load.image("alertGlow",alertGlow);

    
    this.load.image("blurEdge", blurEdge);
    this.load.image("gameOverBox", gameOverBox);
    this.load.image("gameOverWhite", gameOverWhite);
    this.load.image("fullBattery", fullBattery);


    // atlases
    this.load.atlas("runner-atlas", RunnerSpriteTexture, RunnerSpriteData);

    // spritesheets
    this.load.spritesheet("submitButton", submitButton, {
      frameWidth: 530,
      frameHeight: 130,
    });

    this.load.spritesheet("submitButtonNarrow", submitButtonNarrow, {
      frameWidth: 530,
      frameHeight: 130,
    });

    this.load.spritesheet("fanButton", fanButton, {
      frameWidth: 224,
      frameHeight: 224,
    });

    this.load.spritesheet("keyPad", keyPad, {
      frameWidth: 66,
      frameHeight: 66,
    });

    this.load.spritesheet("soundIcon", soundIcon, {
      frameWidth: 100,
      frameHeight: 100,
    });

    this.load.spritesheet("loseBattery", loseBattery, {
      frameWidth: 164,
      frameHeight: 240,
    });

    // audio
    this.load.audio("boop", boopMp3);
    this.load.audio("correctSFX",correctSFX);
    this.load.audio("incorrectSFX",incorrectSFX);
    this.load.audio("pingSFX",pingSFX);

    console.log("Boot::preload::end"); // and our scale manager
  }

  create(): void {
    // everything added to load is now ready.
    console.log("Boot::create::start");

    // see https://github.com/typekit/webfontloader for configuration.
    WebFont.load({
      custom: {
        // example use:
        // declare fontfiles in styles/fonts.scss using @fontface syntax & styles/index.scss in body{}
        families: [],
      },
      google: {
        families: ["Poppins:wght@400;700;900"],
      },
      active: this.webFontsLoaded.bind(this),
      inactive: this.webFontsLoaded.bind(this, false),
    });

    if (
      this.sponge.data.model.scale.attemptFullscreenWherePossible &&
      !this.sponge.data.model.debug
    ) {
      this.input.on("pointerdown", () => {
        this.scale.startFullscreen();
      });
    }

    //set mute on Boot
    this.sound.mute = this.sponge.data.save.audioEnabled ? false : true;


    if(this.game.renderer.type === Phaser.CANVAS){
      this.sponge.data.save.lowPerFormanceMode = true;
      this.cameras.main.setBackgroundColor(0x000000);
    } else {
      this.sponge.data.save.lowPerFormanceMode = false;

    }
  }

  /**
   * a second stage of our load cue just to make sure fonts have been loaded.
   *
   * @memberof Boot
   */
  webFontsLoaded(success: boolean = true): void {
    if (!success) {
      // we may need to look into font fallback at thes point
      console.warn("there was an error loading webfonts.");
    }

    console.log("Boot::webFontsLoaded");

    // some sponge helper classes may need a reference to this state so lets inform the plugin.
    this.sponge.postBoot(this);

    if (!this.sponge.data.model.debug) {
      // any production functionallity to add.
      // Sentry.init({ dsn: 'https://0a015349440b4477ad1d4f348d9e7d85@sentry.io/1492583' });
    } else {
      console.log(this.game);
    }

    //run the second scene defined in out index config
    if (this.sponge.data.model.startScene) {
      this.scene.run(this.sponge.data.model.startScene);
      return;
      this.lazyLoadPhaserScene(this.sponge.data.model.startScene);
      return;
    } else if (this.scene.manager.scenes[1]) {
      this.scene.run(this.scene.manager.scenes[1].scene.key);
      return;
    } else {
      // console.warn("unable to determine which state to load, please check config")
      // reaching here means we might not have instanciated the scene at entry point.
    }
  }

  async lazyLoadPhaserScene(sceneKey: string, start: boolean = true) {
    const Scene = await import(
      /* webpackChunkName: "scene", webpackPreload: true */ "./" + sceneKey
    );

    if (!this.scene.get(sceneKey))
      this.scene.manager.add(sceneKey, Scene.default); //assume default export of module is an extenstion of Phaser.Scene.

    //if we are to imediately start
    if (start) {
      this.scene.run(sceneKey);
    }
  }
}
